<template>
  <div class="f f-gap-48 f-as">
    <div class="fc-g0 fc-b50p">
      <div class="m-b12">
        <div class="t t-lg black m-bx1">About</div>
        <div class="t dark-gray">
          Donut Journeys automates key employee programs like onboarding,
          training, mentorships, and ERGs – and creates structure for teams
          events like happy hours, offsites, and other rituals.
        </div>
      </div>

      <div class="bg-light-purple p-x2 br-4">
        <div class="t bold black">Journeys</div>
        <div class="t ital dark-gray">
          Automate your employee programs
        </div>
        <donut-storylane-preview
          id="gctbxjceyirz"
          class="br-8 m-tx1 mask"
          title="Journeys — Get started"
        />
      </div>
    </div>

    <div class="fc-g0 fc-b50p">
      <div class="t t-lg black m-t28 m-b12">
        Start your first journey
      </div>

      <ul>
        <li v-for="journey in journeys" :key="journey.title">
          <button
            class="button-reset journeys__button w-100p"
            @click="journey.onClick"
          >
            <lucide-icon
              :name="journey.icon"
              :stroke-width="2"
              class="purple"
              :size="48"
            />

            <div>
              <div class="t t-lg black">
                {{ journey.title }}
              </div>
              <div class="t dark-gray">
                {{ journey.description }}
              </div>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { formSubmit } from 'lib/form';

const store = useStore();
const emailMarketingOptIn = store.state.installWizardEmailMarketingOptIn || false;

const props = defineProps({
  flowTypeMetadata: { type: Object, required: true },
  aiFeaturesEnabled: { type: Boolean, default: false },
});

onMounted(() => {
  store.commit('presetBundles/update', {
    key: 'flowTypeMetadata',
    value: props.flowTypeMetadata,
  });
});

const journeys = [
  /*
  {
    icon: 'Sparkles',
    title: 'Create with AI',
    description:
      'Generate a custom Journey quickly and easily with our built in AI tool.',
  },
  */
  {
    icon: 'FileSearch',
    title: 'Browse Presets',
    description:
      // TODO update the copy here
      props.aiFeaturesEnabled
        ? 'Generate a custom Journey quickly and easily with our built in AI tool.'
        : 'Generate a custom Journey quickly and easily.',
    onClick: () => {
      window.donut.track('/wizard: clicked journeys browse presets');

      formSubmit({
        method: 'post',
        action: '/onboarding/tags/wizard',
        fields: {
          email_marketing_opt_in: emailMarketingOptIn,
        },
      });
    },
  },
  {
    icon: 'Plus',
    title: 'Blank Journey',
    description:
      'Start your Journey from scratch and add all the messages you want.',
    onClick: () => {
      window.mixpanel.track('/wizard: clicked journeys blank journey');

      store.commit('updateModal', {
        visible: true,
        subcomponent: 'preset-bundles-modals-new-tag',
        size: 'of-v',
        data: { emailMarketingOptIn, bundle: {} },
      });
    },
  },
];
</script>

<style scoped lang="scss">
@import '../../../assets/stylesheets/donut.scss';

content.donut .journeys__button {
  padding: 24px;

  border-radius: 8px;
  border: 1px solid $border;

  text-align: left;

  display: flex;
  gap: 24px;
  align-items: center;

  transition: border-color 0.15s, background-color 0.15s, outline 0.15s;

  &:hover {
    /* also add outline to mimic 2px thick border without causing layout shift */
    outline: 1px solid $purple;
    border-color: $purple;
    background-color: $hover-bg;
  }
}
</style>
